// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"281":"a8c7383d","307":"b1ca99ef","674":"559eefc4","708":"acbb15b4","974":"47f0f870"}[chunkId] + ".css";
};